import { UserSchema } from "../volateq-api/api-schemas/user-schemas";
import { ApiTechnology } from "../volateq-api/api-technologies";
import { VolateqOfflineApi } from "../volateq-api/offline/volateq-offline-api";

export class UserService {
  private meUser: UserSchema | null = null;

  private refreshMePromise: Promise<UserSchema> | null = null; 

  public async me(): Promise<UserSchema> {
    if (this.meUser === null) {
      await this.refreshMe();
    }

    return this.meUser!;
  }

  public async refreshMe() {
    if (this.refreshMePromise === null) {
      this.refreshMePromise = VolateqOfflineApi.getCommon().getMe();
    }
    
    try {
      this.meUser = await this.refreshMePromise;
    } finally {
      this.refreshMePromise = null;
    }

  }

  public async isCspPtcUser(): Promise<boolean> {
    const plants = (await this.me()).plants || [];
    return plants.length > 0 && !plants.find(p => p.technology_id !== ApiTechnology.CSP_PTC)
  }
}

export const userService = new UserService();